import { type HttpErrorResponse } from '@angular/common/http';
import { type IncidentModel } from '@models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const IncidentsActions = createActionGroup({
  events: {
    'Add Incident': props<{ incident: IncidentModel; }>(),
    'Load All Incident Error': props<{ error: HttpErrorResponse; }>(),
    'Load All Incident Success': props<{ incidents: IncidentModel[]; }>(),
    'Load All Incidents': emptyProps(),
    'Reset Incidents': emptyProps(),
    'Resolve Incidents': props<{ incidents: IncidentModel[]; }>(),
  },
  source: 'Incidents',
});
